import { t } from 'ttag'
import { useMutation } from 'react-query'

import { Field } from '@h2/components/inputs/field'
import { TextInput } from '@h2/components/inputs/text'
import { TextArea } from '@h2/components/inputs/textArea'
import { Button } from '@h2/components/buttons/button'
import { useForm } from '@h2/common/components/hooks/useForm'
import { api, errors } from '@h2/api'

const CustomOptionForm = ({ budget, roundId, onComplete, updateBudget }) => {
  const { register, error, dispatch, isInvalid, handleOnSubmit } = useForm({
    expenseName(form) {
      if (!form.expenseName?.trim()) {
        return t`A valid name is required`
      }
    },
    monthlyCost(form) {
      if (!form.monthlyCost?.trim()) {
        return t`A valid cost is required`
      }
    }
  })
  const { mutate, isLoading: isSubmitting } = useMutation(
    form =>
      api.fetch(`/budget/${budget.id}/custom/${roundId}`, {
        method: 'POST',
        body: JSON.stringify(form)
      }),
    {
      onSuccess: newBudget => {
        updateBudget(newBudget)
        onComplete(newBudget)
      },
      onError: err => {
        const formErrors = errors.getValidation(err)

        if (formErrors) {
          dispatch({ type: 'validate', payload: formErrors })
        }
      }
    }
  )

  return (
    <form onSubmit={handleOnSubmit(form => mutate(form))}>
      <Field
        isRequired
        label={t`What is the expense?`}
        desc={error.expenseName}
        status={error.expenseName ? 'error' : 'default'}>
        <TextInput
          placeholder={t`Enter the name of the payee or a short title describing the expense.`}
          {...register('expenseName')}
        />
      </Field>
      <Field
        isRequired
        label={t`What is the monthly cost?`}
        desc={error.monthlyCost}
        status={error.monthlyCost ? 'error' : 'default'}>
        <TextInput
          placeholder={`If you pay annually, divide the cost by 12`}
          {...register('monthlyCost')}
        />
      </Field>
      <Field
        label={t`Description`}
        desc={error.description}
        status={error.description ? 'error' : 'default'}>
        <TextArea
          placeholder={t`In a few sentences, you can describe what the expense is. This is optional, but may help you later identify what the expense was for.`}
          {...register('description')}
        />
      </Field>
      <Button
        type="submit"
        isLoading={isSubmitting}
        isDisabled={isSubmitting || isInvalid}>
        {t`Save Option`}
      </Button>
    </form>
  )
}

export { CustomOptionForm }
